import {
  ListingsSearchAllFilters,
  ListingsStreetSearchAllFilters,
} from '../types';

export function isStreetSearch(
  allFilters: ListingsSearchAllFilters,
): allFilters is ListingsStreetSearchAllFilters {
  return (
    !!allFilters.citySlug &&
    !!allFilters.cityName &&
    !!allFilters.streetSlug &&
    !!allFilters.streetName
  );
}
